const state = {
	id: null,
	role: null,
	isEstate: null,
	firstname: '',
	lastname: '',
	email: '',
	picture: null,
	token: null,
	refresh: null,
	token_duration: null,
	phone: null,
	address: {
		line: null,
		zip: null,
		city: null,
		country: null
	},
	advisors: [],
	investment_stats: [],
	birthdate: null,
	tutorialFinished: false,
	isForceCompleteProfile: false
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/Users/state.js